import React from 'react';
import { ButtonPrimary } from '../../../../../utils/Button';

function InvoiceActionsRow({ openModal, invoiceData }) {
    return (
        <div className="">
            <div className="mb-4">
                <h2 className="text-primary text-xl font-normal">Actions</h2>
            </div>

            <div className="flex flex-wrap gap-3">
                <span>
                    <ButtonPrimary
                        title="Update Invoice Note"
                        onClick={() => openModal('update_invoice_note')}
                        disabled={invoiceData?.status === 'canceled'}
                    />
                </span>
            </div>
        </div>
    );
}

export default InvoiceActionsRow;
